(function() { window.GUID_84f77079_b194_4155_9ecf_0653b6471d90 = { getGuid: function() { return "84f77079-b194-4155-9ecf-0653b6471d90"; } }; })();
var CS;
(function (CS) {
    let Ajax;
    (function (Ajax) {
        let isAlreadyCalled;
        let currentRequest;
        let currentRequestUrl;
        let currentRequestData;
        let AjaxCallType;
        (function (AjaxCallType) {
            AjaxCallType["GET"] = "GET";
            AjaxCallType["POST"] = "POST";
        })(AjaxCallType = Ajax.AjaxCallType || (Ajax.AjaxCallType = {}));
        function AjaxNavigationCall(url, data, source, callback, replacePopState = false) {
            if (url)
                console.info("ajax call success: " + url + " " + isAlreadyCalled);
            //Don't prevent source Pop since can happen many quick back button
            if (isAlreadyCalled && source != CS.Nav.Source.Pop) {
                return;
            }
            if (currentRequest != null && source == CS.Nav.Source.Pop) {
                currentRequest.abort();
            }
            isAlreadyCalled = true;
            let extraParams = createExtraParams((e) => {
                (e.isNavigation = true),
                    (e.isRefresh = source == CS.Nav.Source.Refresh),
                    (e.makeUIReadOnly = true);
            });
            let callType = AjaxCallType.GET;
            if (source == CS.Nav.Source.Post) {
                callType = AjaxCallType.POST;
            }
            return call(url, callType, false, data, extraParams, (response, headerValues) => {
                callback.call(this, response, headerValues);
            }, source, replacePopState);
        }
        Ajax.AjaxNavigationCall = AjaxNavigationCall;
        // TODO: Would be nice to add error handling callback un peu comme le callback de success
        function Get(url, data, callback, extraParamsOverride = null) {
            let extraParams = createExtraParams((e) => {
                e.showTopBuzyIndicator = true;
            });
            if (extraParamsOverride) {
                extraParamsOverride(extraParams);
            }
            return call(url, AjaxCallType.GET, false, data, extraParams, callback);
        }
        Ajax.Get = Get;
        function Post(url, data, callback, extraParamsOverride = null) {
            let extraParams = createExtraParams((e) => {
                (e.makeUIReadOnly = true), (e.showTopBuzyIndicator = true);
            });
            if (extraParamsOverride) {
                extraParamsOverride(extraParams);
            }
            return call(url, AjaxCallType.POST, false, data, extraParams, callback);
        }
        Ajax.Post = Post;
        function AppendDataToUrl(url, data) {
            if (!data)
                return url;
            const [baseUrl, existingQuery] = url.split("?");
            const existingParams = new URLSearchParams(existingQuery || "");
            const newParamsString = $.param(data);
            const newParams = new URLSearchParams(newParamsString);
            newParams.forEach((value, key) => {
                existingParams.set(key, value);
            });
            const queryString = existingParams.toString();
            return queryString ? `${baseUrl}?${queryString}` : baseUrl;
        }
        Ajax.AppendDataToUrl = AppendDataToUrl;
        function call(url, type, postFile, data, extraParams, callback, source, replacePopState = false) {
            if (!extraParams) {
                extraParams = createExtraParams();
            }
            if (url == currentRequestUrl && currentRequest) {
                if (extraParams.checkOnlyDoubleCallUrl ||
                    JSON.stringify(currentRequestData) == JSON.stringify(data)) {
                    if (extraParams.doubleCallAllowed == false) {
                        return;
                    }
                    if (extraParams.abortOnDoubleCall == true) {
                        console.info("aborting last ajax");
                        currentRequest.abort();
                    }
                }
            }
            data = data ? data : {}; //Evite la gestion de null mais est-ce necessaire??, a tester
            Ajax.AjaxListener.NotifyAjaxStateChanged(Ajax.AjaxState.Start, extraParams, url);
            if (data instanceof FormData) {
                type = AjaxCallType.POST;
                postFile = true;
                extraParams.isRefresh = true;
            }
            if (type == AjaxCallType.POST) {
                extraParams.isPost = true;
            }
            CS.TimeoutHelper.Start(url);
            currentRequestUrl = url;
            currentRequestData = data;
            let antiforgeryTokenValue = $("input[name=__RequestVerificationToken]")
                .first()
                .val();
            let ajaxParams = {
                async: extraParams.isSync != true,
                cache: true, //Doit etre a true puisque nous appendons nous meme un dummydate pour forcer un refresh, donc, ca evite une double technique
                dataType: "text",
                type: type,
                processData: !postFile,
                url: appendForceRefreshOnUrl(url),
                data: data,
                headers: {
                    RequestVerificationToken: antiforgeryTokenValue,
                    sessionData: data.sessionData,
                    isnavigation: extraParams.isNavigation,
                    forcefullviewoverview: extraParams.isRefresh,
                    signalrconnectionid: CS.GlobalConst.EnableSignalR &&
                        CS.SignalRHelper.Instance &&
                        extraParams.includeSignalRId
                        ? CS.SignalRHelper.Instance.ConnectionId
                        : "", // s'assurer que l'objet existe
                },
                success: function (response, status, jqXHR) {
                    clearLastData();
                    let headerValues = handleHeaderValues(jqXHR, response);
                    if (shouldFullNavigateForModernAssetBoundary(extraParams, headerValues)) {
                        forceFullNavigation(url, data, headerValues, source, type, extraParams, replacePopState);
                        return;
                    }
                    Ajax.AjaxListener.NotifyAjaxStateChanged(Ajax.AjaxState.Succeed, extraParams, url);
                    let $newScripts = $();
                    if (headerValues.actionResultFormat == "view") {
                        let $ajaxResponse = $(response);
                        let commonData = $ajaxResponse
                            .find("#commondataserialized")
                            .data("val");
                        CS.CommonData.Current.RefreshFromSmartResponse(commonData);
                        CS.DOM.$body.trigger("ajaxnavigating");
                        CS.DOM.$body.trigger("sectionmasterreplacing");
                        CS.Views.MasterPage.Instance.RefreshNavigationInformations();
                        if (!CS.DOM.$sectionMaster) {
                            CS.DOM.FindDOMSections();
                        }
                        if (CS.DOM.$sectionMaster) {
                            CS.DOM.$sectionMaster.replaceWith(response);
                        }
                        CS.Views.MasterPage.RemoveLastBodyClasses();
                        Ajax.AjaxListener.NotifyAjaxStateChanged(Ajax.AjaxState.PageContentReplaced, extraParams, url);
                        CS.DOM.$body.trigger("sectionmasterreplaced");
                        if (headerValues.popStateCreated) {
                            CS.PopState.OnNavigation(window.location.href + "?pop=true", false);
                        }
                    }
                    else if (headerValues.actionResultFormat == "json") {
                        response = JSON.parse(response);
                        if (headerValues.actionResultContainScripts) {
                            $newScripts = $(response.scripts);
                        }
                    }
                    else if (
                    /*Les else ne servent pas a grand chose, mais c'est pour etre clair, la majorité des cas, cest le if (callback) qui fait le reste dans ces cas de figure
                                                      Seule l'extraction des scripts du contenu est faite */
                    headerValues.actionResultFormat == "partialview" ||
                        headerValues.actionResultFormat == "content") {
                        if (headerValues.actionResultContainScripts) {
                            let scriptTagIndex = response.indexOf("<script>");
                            if (scriptTagIndex > -1) {
                                $newScripts = $(response.substring(scriptTagIndex));
                                response = response.substring(0, scriptTagIndex);
                            }
                        }
                    }
                    if (callback) {
                        callback.call(this, response, headerValues);
                    }
                    if (headerValues.actionResultContainScripts) {
                        $newScripts.addClass("ajax-appended");
                        CS.DOM.$sectionMaster.append($newScripts);
                        Ajax.AjaxListener.NotifyAjaxStateChanged(Ajax.AjaxState.SmartScriptsExecuted, extraParams, url);
                    }
                    Ajax.AjaxListener.NotifyAjaxStateChanged(Ajax.AjaxState.CallEnded, extraParams, url);
                },
                error: function (xhr, status, error) {
                    clearLastData();
                    if (status != "abort") {
                        Ajax.AjaxListener.NotifyAjaxStateChanged(Ajax.AjaxState.Error, extraParams, url);
                        var ajaxError = {
                            status: status,
                            statusCode: xhr.status,
                            error: error,
                            message: xhr.responseText,
                            isNavigationError: xhr.getResponseHeader("isnavigationerror") == "True",
                        };
                        HandleError(ajaxError, extraParams);
                    }
                },
            };
            if (postFile) {
                ajaxParams.contentType = false;
            }
            currentRequest = $.ajax(ajaxParams);
            return currentRequest;
        }
        function HandleError(error, params) {
            clearLastData();
            CS.Controls.CSError.Current.Show(error);
            if (CS.CommonData.Current.IsNativeApp && params.isNavigation) {
                //Le but ici est d'informer Xamarin que l'erreur fut handlé par le javascript
                //Nous devrons peut etre revoir ceci parcontre, a suivre...
                CS.NativeApp.NA_NavigationError(JSON.stringify(error));
            }
        }
        Ajax.HandleError = HandleError;
        function appendForceRefreshOnUrl(url) {
            if (CS.Helper.isNullOrWhiteSpace(url)) {
                return url;
            }
            let splittedSharpChar = url.split("#");
            url = splittedSharpChar[0];
            if (url.indexOf("?") > -1) {
                url = url + "&dummyDate=" + Date.now();
            }
            else {
                url = url + "?dummyDate=" + Date.now();
            }
            let sharpValue = splittedSharpChar.length == 2 ? splittedSharpChar[1] : null;
            if (sharpValue) {
                url += "#" + sharpValue;
            }
            return url;
        }
        function handleHeaderValues(jqueryXHR, response) {
            var _a;
            const browserUrlReplaceCacheKey = ((_a = document
                .getElementById("browserurlreplacecachekey")) === null || _a === void 0 ? void 0 : _a.getAttribute("value")) || "browserurlreplace";
            const browserUrlReplace = jqueryXHR.getResponseHeader(browserUrlReplaceCacheKey);
            let navigationContextId = jqueryXHR.getResponseHeader("_navigationcontextid");
            let actionResultFormat = jqueryXHR.getResponseHeader("actionresultformat");
            let actionResultContainScripts = jqueryXHR.getResponseHeader("actionresultcontainscripts");
            let popStateCreated = jqueryXHR.getResponseHeader("popStateCreated");
            const modernBlazorUiHeader = jqueryXHR.getResponseHeader("cs-modern-blazor-ui");
            let result = {
                hasChangeUrl: false,
                newUrl: null,
                popStateCreated: (popStateCreated === null || popStateCreated === void 0 ? void 0 : popStateCreated.toLowerCase()) == "true",
                actionResultFormat: actionResultFormat,
                actionResultContainScripts: actionResultContainScripts == "True",
                usesModernBlazorUi: (modernBlazorUiHeader === null || modernBlazorUiHeader === void 0 ? void 0 : modernBlazorUiHeader.toLowerCase()) === "true",
                hasModernBlazorUiHeader: modernBlazorUiHeader != null,
            };
            if (browserUrlReplace &&
                browserUrlReplace != window.location.pathname &&
                browserUrlReplace != "nonav") {
                result.hasChangeUrl = true;
                result.newUrl = browserUrlReplace;
            }
            if (navigationContextId) {
                $("#page-context-unique-id").val(navigationContextId);
            }
            if (response != null && !result.actionResultContainScripts) {
                //Dans le cas ou le header ne nous dit pas si le contenu contient des scripts, il est possible que la reponse en contienne quand meme.
                //Dans le cas des JsonResult et ContentResult, result.actionResultContainScripts est fonctionnel puisque les scripts
                //sont toujours ajouté avant l'exécution de ContentResult mais dans le cas des partialview, les scripts peuvent etre ajouté
                //via le rendering lui meme des vues, et à ce moment là, le header ne peut pu etre modifié puisqu'il est déjà encour d'envoi au client.
                if (result.actionResultFormat == "partialview") {
                    result.actionResultContainScripts =
                        getActionResultContainScripts(response);
                }
            }
            return result;
        }
        function shouldFullNavigateForModernAssetBoundary(extraParams, headerValues) {
            if (!extraParams.isNavigation) {
                return false;
            }
            if (headerValues.actionResultFormat !== "view") {
                return false;
            }
            if (!headerValues.hasModernBlazorUiHeader) {
                return true;
            }
            const currentHasModernAssets = currentDocumentHasModernAssets();
            const targetNeedsModernAssets = headerValues.usesModernBlazorUi;
            return currentHasModernAssets !== targetNeedsModernAssets;
        }
        function currentDocumentHasModernAssets() {
            var _a;
            return ((_a = document.body) === null || _a === void 0 ? void 0 : _a.dataset.csModernBlazorUi) === "true";
        }
        function forceFullNavigation(url, data, headerValues, source, type, extraParams, replacePopState) {
            const targetUrl = getFullNavigationUrl(url, data, headerValues, type);
            if (!targetUrl) {
                handleUnsupportedModernAssetBoundaryPost(extraParams, url);
                return;
            }
            if (source === CS.Nav.Source.Pop || replacePopState) {
                window.location.replace(targetUrl);
                return;
            }
            window.location.assign(targetUrl);
        }
        function getFullNavigationUrl(url, data, headerValues, type) {
            if (headerValues.newUrl) {
                return headerValues.newUrl;
            }
            if (type === AjaxCallType.POST) {
                return null;
            }
            return CS.Ajax.AppendDataToUrl(url, data);
        }
        function handleUnsupportedModernAssetBoundaryPost(extraParams, url) {
            const message = "CS.App cannot cross the modern Blazor asset boundary after a POST without a canonical navigation URL.";
            console.error(message);
            Ajax.AjaxListener.NotifyAjaxStateChanged(Ajax.AjaxState.Error, extraParams, url);
            HandleError({
                status: "unsupported",
                statusCode: 0,
                error: "modern-asset-boundary-post",
                message: message,
                isNavigationError: true,
            }, extraParams);
        }
        function getActionResultContainScripts(response) {
            return response.lastIndexOf("</script>") > -1;
        }
        function createExtraParams(extraParamsOverride = null) {
            let extraParams = {
                includeSignalRId: false,
                showTopBuzyIndicator: false,
                makeUIReadOnly: false,
                isNavigation: false,
                isRefresh: false,
                isPost: false,
                isSync: false,
                doubleCallAllowed: false,
                checkOnlyDoubleCallUrl: false,
                abortOnDoubleCall: false,
            };
            if (extraParamsOverride) {
                extraParamsOverride(extraParams);
            }
            return extraParams;
        }
        function clearLastData() {
            CS.TimeoutHelper.Clear();
            isAlreadyCalled = false;
            currentRequest = null;
            currentRequestData = null;
            currentRequestUrl = null;
        }
    })(Ajax = CS.Ajax || (CS.Ajax = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-ajax.js.map
